import { FC, ReactNode } from 'react'
import { Link, To } from 'react-router-dom'
import { ExportOutlined } from '@ant-design/icons'

interface Props {
  to: To
  content: ReactNode
  icon?: ReactNode
  iconPosition?: 'prefix' | 'suffix'
}

const ExternalLink: FC<Props> = ({
  to,
  content,
  icon = <ExportOutlined />,
  iconPosition = 'prefix',
}) => (
  <Link to={to} target="blank">
    {iconPosition === 'prefix' && icon} {content}{' '}
    {iconPosition === 'suffix' && icon}
  </Link>
)

export { ExternalLink }
